import { apificateDate } from '@/helpers/formatDate'

export const apificate = (state) => {
  let {
    from,
    to,
    period
  } = state

  return {
    from: apificateDate(from),
    to: apificateDate(to),
    period
  }
}
